import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import APIv2Box from 'components/Frequently_Asked_Question/WQHD_MQTTv5_Alarmserver_APIv2_NodeRED/PrimaryBox';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Smarthome/Alarm_Server/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmPerm';
import ASTable from 'components/Web_User_Interface/1440p_Series/Smarthome/Alarm_Server/asTable';
import PrimaryBox from 'components/Web_User_Interface/1440p_Series/Smarthome/Alarm_Server/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Alarm Menü // Alarm Server",
  "path": "/Web_User_Interface/1440p_Serie/Smarthome/Alarm_Server/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Sie können die Alarmserver-Funktion nutzen um einen HTTP-Request zu einem verbundenen Server zu senden. Der Server benötigt eine kompatible Software um diesen Request als Alarm zu interpretieren und weitere Aktionen folgen zu lassen. Diese Funktion wird oft von Smart-Home Alarmsystemen unterstützt. Sie können eigene Kommandos zum Request hinzufügen, um spezielle Aktionen in der Serversoftware auszulösen.",
  "image": "./WebUI_1440p_SearchThumb_Smarthome_Alarmserver.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Smarthome_Alarmserver.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='SMARTHOME Menü – Alarmserver – INSTAR Wiki' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Nutzen Sie die Alarmserver-Funktion unterm SMARTHOME Menü auf INSTAR Full-HD-Weboberfläche, um einen HTTP-Request zum verbundenen Server zu senden.' image='/images/Search/WebUI_1440p_SearchThumb_Smarthome_Alarmserver.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Smarthome_Alarmserver.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Alarm/Alarm_Server/' locationFR='/fr/Web_User_Interface/1440p_Series/Alarm/Alarm_Server/' crumbLabel="Alarm Server" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "smarthome-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#smarthome-men%C3%BC",
        "aria-label": "smarthome menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Smarthome Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/785057f43ff603604c765fa8d0e4fa4e/610c0/1440p_Settings_Alarm_Alarmserver.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.60869565217392%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAC5ElEQVQ4y22TS28aZxSG+Rd1LwnYhngumDImEjYMzB0mGPAwAzMDmAQ7TpQ2aVUn7aKq1FWqVkpU2VlWjbppd/0F/XNP9Q2B5tLFq1nNo+c953w5RVFYRaW4U6DS6OJ9+Qrz4gWt83ejn73AvHiJ/8WvSFqDTz7+iHq9Tq1WY2tri0KhQE5V1QwoKwq3SkXMbsjs22viyyvG31wRP73eZHJ5TfLsFdPLlzTaXaoVDb1pcHSko1VrqOo+ubWhJElIkoxj2oyCIfPTBcvlGUmaEicp40lMkqRE45hg2OfkZIJl+rR0i5ZuY5kdNO32ylCW5Q3Qtj3iOGE2mzGdTgnDkCiKsoyjkCieEk3PiKNzOnYP27Ix2jbtlpNZZoZvA50MGGdQARuNQqJkQTRdEqV3CWfnhPGcR9GcJBjQcU1MQ0D/FyjhuS5JkmRQAQyCAMt20FttmnqLw6Mm/V6P518lPLrv0vMN9KaFaThoWu39yhKu4zKZTLKKK8MRvu/jeS6e5+G6DkEQ8vOPD7k4bePaJmbbxLVsDrSD/wxleV3ZzezSNM1mOB6PM/D6e3q6YHF3yd9XP/HDgwijrdOxTTzHWgE3hvJ6KS5xEmewtamwDEcjgmDEvTQmXab889vv/PXdExxTx7UsLFPM8ANDaQV8YyhgYoaO42AYBrbj0HVM+sEd/vzjNa+/f8z0uI2uG5hti+rnbxmKFIul7OoFUCxGGAq7wWBAv99n0D+mH4w5Gc9p6g3KqoyyV6RYLGb/7uzsklsvZAUsUq1WM+C6qkiv16Pb9el2Ovj+McNRjCzt8elnN8gXCtmTWycnvbETT08ANU3L7ETEIsTcLNOgeXibRuOQWrOBd8enUqmQz+fZ3t5+J7n1uWwMNW1zLuKog5MhQXyP0ZNfWMwf89zv8fXxEFlVyd+8+SFQUcuIyIrKniRRKpXY39+nXC6jqmVURUatHKDWbbRqHWtPoi4r7OzuZhXfB/4LhU0SkBs25kMAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/785057f43ff603604c765fa8d0e4fa4e/e4706/1440p_Settings_Alarm_Alarmserver.avif 230w", "/de/static/785057f43ff603604c765fa8d0e4fa4e/d1af7/1440p_Settings_Alarm_Alarmserver.avif 460w", "/de/static/785057f43ff603604c765fa8d0e4fa4e/7f308/1440p_Settings_Alarm_Alarmserver.avif 920w", "/de/static/785057f43ff603604c765fa8d0e4fa4e/42d56/1440p_Settings_Alarm_Alarmserver.avif 1295w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/785057f43ff603604c765fa8d0e4fa4e/a0b58/1440p_Settings_Alarm_Alarmserver.webp 230w", "/de/static/785057f43ff603604c765fa8d0e4fa4e/bc10c/1440p_Settings_Alarm_Alarmserver.webp 460w", "/de/static/785057f43ff603604c765fa8d0e4fa4e/966d8/1440p_Settings_Alarm_Alarmserver.webp 920w", "/de/static/785057f43ff603604c765fa8d0e4fa4e/a8acc/1440p_Settings_Alarm_Alarmserver.webp 1295w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/785057f43ff603604c765fa8d0e4fa4e/81c8e/1440p_Settings_Alarm_Alarmserver.png 230w", "/de/static/785057f43ff603604c765fa8d0e4fa4e/08a84/1440p_Settings_Alarm_Alarmserver.png 460w", "/de/static/785057f43ff603604c765fa8d0e4fa4e/c0255/1440p_Settings_Alarm_Alarmserver.png 920w", "/de/static/785057f43ff603604c765fa8d0e4fa4e/610c0/1440p_Settings_Alarm_Alarmserver.png 1295w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/785057f43ff603604c765fa8d0e4fa4e/c0255/1440p_Settings_Alarm_Alarmserver.png",
              "alt": "Web User Interface - 1440p Series - Alarm Server",
              "title": "Web User Interface - 1440p Series - Alarm Server",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <ASTable mdxType="ASTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PrimaryBox mdxType="PrimaryBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h2 {...{
      "id": "alarmserver-einführung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#alarmserver-einf%C3%BChrung",
        "aria-label": "alarmserver einführung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Alarmserver Einführung`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Bewegungserkennung/Alarm_Server/"
        }}>{`INSTAR Alarmserver`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Frequently_Asked_Question/Alarmserver_Testing/"
        }}>{`Testen des Alarmservers`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Frequently_Asked_Question/WQHD_Alarmserver_Custom_Headers/"
        }}>{`Alarmserver mit Benutzerdefinierten Headern`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Frequently_Asked_Question/Debugging_Alarmserver_Headers/"
        }}>{`Testen von Alarmserver Header und Queries`}</a></li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/6937a/Alarm_Alarmserver_Testing_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "77.39130434782608%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAC9UlEQVQ4y22TW4/bRBiG8zuQYDeHpj7kUDbZlCZN6uzm6N0ktseHib0OXSWLUDlcQCtVQFFVLgpXSFwg8Q8oXKCCuOHPPWjsbaCUi1efZ/zN43defS6Ir17gP/uT1dcvWTx5yXKv31l8+RsX3/6F/emPnOy+y/anj14wefTL63r4M97TPxjtnlNYCkn0/ocE6RVh+kGuTS61t758wMl4xg2txnHX4uh2n6P3Bm+o3bWo6jUK54sVMknZ3N8SyhgRSkQQ4fkhIpAEMsGyhrRbLSIp8X2fIAgIgryqtRAie67X6xQcx2EtJWEY4HkuwvP2TcJziNId1viM4+M28uKSIIyQUu6lel3XzYCNRiMH/vuF8EN8mWYSUYLcXGGdTjhut4njOPuo53lvaA9cOQ5hGOYwIZjOZliWxWAwoN/vMxxa9LpdOp3bJEnyv7DXgMqhWqiaAafTDDgcDrN6enpKr9ej0+mQXiSEgY+vYlGRCJED1ZV9/9rhapVdOYqiDKwaxHWzcr3dbplMJhy12nhRipoKP04QKmfPY+W6zFyXRfAfoLq2Ar6CvQLudltGkwndTovvPw94/rHDR8tzIk/gBQGp8Hm6dHksAhrNJgV1SIXt+zlgsVgwn8+Z23PmU5tNeE5/1qfVaPAwHfFJZBHd7TG2hgyGQ6aDe+x6A9J7Fpqm5cD1Ot6Hu1wusW0b+8zGntmk0QrrbMjB24ccVk0OKjolTaNSqVAulSiWy7xVLvHOTZ2DYpmCgsTr9X5s/snQx3Md0ssrJvaS4uEB9ZqJoWsYuo5hGJimiamqrnOr2cwdqoNSrnFcNwOqLNWQqwhU8HGSMB6PKZZKmLUamqZnBw0FM80MnMk0qVarFIS7YhOHrAOBdz1C6hf0o5jI90nDiPFoRKlUpFnPHWVA5dI00Y1a5rBmGDnw8f0Zvz6x+UaOuZzMWQmP4MEz3M9+4AtH8tPZEsc64V3jgHBQ5c6tKlVNR9duYrQt9Dtz7mo15pUqjcoN/gZ2FjW62aIUfQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/e4706/Alarm_Alarmserver_Testing_01.avif 230w", "/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/d1af7/Alarm_Alarmserver_Testing_01.avif 460w", "/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/7f308/Alarm_Alarmserver_Testing_01.avif 920w", "/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/feccc/Alarm_Alarmserver_Testing_01.avif 1094w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/a0b58/Alarm_Alarmserver_Testing_01.webp 230w", "/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/bc10c/Alarm_Alarmserver_Testing_01.webp 460w", "/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/966d8/Alarm_Alarmserver_Testing_01.webp 920w", "/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/e4bbf/Alarm_Alarmserver_Testing_01.webp 1094w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/81c8e/Alarm_Alarmserver_Testing_01.png 230w", "/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/08a84/Alarm_Alarmserver_Testing_01.png 460w", "/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/c0255/Alarm_Alarmserver_Testing_01.png 920w", "/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/6937a/Alarm_Alarmserver_Testing_01.png 1094w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/63a8d8a1bbd4e2e43ccc1db30b1c28ee/c0255/Alarm_Alarmserver_Testing_01.png",
              "alt": "Web User Interface - 1440p Series - Alarm Server",
              "title": "Web User Interface - 1440p Series - Alarm Server",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "beispiele-für-die-nutzung-von-alarmserver",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#beispiele-f%C3%BCr-die-nutzung-von-alarmserver",
        "aria-label": "beispiele für die nutzung von alarmserver permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Beispiele für die Nutzung von Alarmserver`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <APIv2Box mdxType="APIv2Box" />
    <EuiSpacer mdxType="EuiSpacer" />
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Software/Andere_Plattform/Loxone_Miniserver/#nutzen-sie-den-loxone-miniserver-als-alarmserver"
        }}>{`Loxone Miniserver`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Software/Andere_Plattform/Homematic_IP/#verwendung-der-homematic-ccu3-als-alarmserver-f%C3%BCr-unsere-kamera"
        }}>{`Homematic IP CCU3`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Erweitert/Homematic_CCU3_und_RedMatic/#instar-ip-kamera---homematic"
        }}>{`Homematic & RedMatic`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Software/Andere_Plattform/Athom_Homey/#homey-benachrichtigen-wenn-der-kamera-alarm-ausgel%C3%B6st-wird-alarm-server"
        }}>{`Homey`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Software/Andere_Plattform/Homee/#kamera-alarmserver-und-homee-webhook"
        }}>{`homee`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Software/Linux/Home_Assistant/#verwendung-von-home-assistant-als-alarmserver-f%C3%BCr-ihre-instar-kamera"
        }}>{`Home Assistant`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Erweitert/IFTTT_als_Alarmserver/"
        }}>{`IFTTT`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Erweitert/Node-RED_und_MQTT/Projekte/Alarm_Aufnahme_und_Nachtsicht/"
        }}>{`Node-RED unter Windows`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Erweitert/openHABian_auf_Raspberry_Pi/Projekte/Alarm_Aufnahme_und_Nachtsicht/"
        }}>{`Node-RED auf einem Raspberry Pi (openHabian)`}</a></li>
    </ul>
    <h2 {...{
      "id": "mit-alarmserver-queries-arbeiten",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#mit-alarmserver-queries-arbeiten",
        "aria-label": "mit alarmserver queries arbeiten permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Mit Alarmserver Queries arbeiten`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Frequently_Asked_Question/Alarmserver_Testing/"
        }}>{`Testen des HTTP Alarmservers`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Erweitert/Alarmserver_Queries_for_your_Smarthome/"
        }}>{`Alarmserver Queries für Ihr Smarthome`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      